import { CHANGE_LANGUAGE_TO_THAI, CHANGE_LANGUAGE_TO_ENG, Action } from '../action/language'
import { defaultLanguage } from '../../i18n/Config'

type State = 'th' | 'en'

const initializeState = defaultLanguage as State

const languageReducer = (state = initializeState, action: Action): State => {
    switch (action.type) {
        case CHANGE_LANGUAGE_TO_THAI: {
            return 'th'
        }

        case CHANGE_LANGUAGE_TO_ENG: {
            return 'en'
        }

        default:
            return state
    }
}

export default languageReducer
